module.exports = __webpack_public_path__ + "img/4.4cc3bc6c.jpg";